export const LogoMark = ({ className = "h-9 w-9" }) => (
    <svg viewBox="0 0 40 40" className={className} role="img" aria-label="Fall Safe Ready logo mark">
        <circle cx="20" cy="20" r="20" fill="#0B192C" />
        <path d="M7.5 25.5c6 6.5 17.5 6 24-1.5" fill="none" stroke="#2DD4BF" strokeWidth="3" strokeLinecap="round" />
        <circle cx="14.5" cy="12.5" r="3.4" fill="#F59E0B" />
        <path d="M15 16.8l7.8 6.2" stroke="#FDFBF7" strokeWidth="3" strokeLinecap="round" />
    </svg>
);

export const Logo = () => (
    <span className="flex items-center gap-2.5">
        <LogoMark />
        <span className="site-wordmark whitespace-nowrap font-display text-xl font-extrabold tracking-tight text-ink">
            Fall Safe Ready
        </span>
    </span>
);